import { useState } from 'react';
import { DetailsPanel, EditIcon, FormatInformation, IconButton } from '@weareopenr/component-library';
import type { IMenuItem } from 'src/types/menu.types';
import GlobalItemTaxRateEditModal from '../GlobalItemTaxRateEditModal';
import type { IAggregator } from 'src/types/aggregator.types';
import { useAuthWrapper } from '@weareopenr/authkit';
import { FEATURE_FLAGS } from 'src/constants';

export interface TaxRatePanelProps {
  item: IMenuItem;
  aggregators: IAggregator[];
}

const TaxRatePanel = ({ item, aggregators }: TaxRatePanelProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const handleModalClick = () => setIsModalOpen((prev: boolean) => !prev);
  const { featureFlags } = useAuthWrapper();
  return (
    <>
      <GlobalItemTaxRateEditModal
        isModalOpen={isModalOpen}
        onModalClose={handleModalClick}
        currentItem={item}
        aggregators={aggregators}
      />
      <DetailsPanel
        title="Tax Rate"
        action={
          <IconButton onClick={handleModalClick} aria-label="Edit tax rate" icon={EditIcon} buttonStyle="ghost" />
        }
      >
        <FormatInformation heading="Tax rate">
          {item.tax_rate ? `${item.tax_rate}%` : 'No Tax Rate Provided'}
        </FormatInformation>
        {featureFlags.includes(FEATURE_FLAGS.DEPOSIT_RETURN_SCHEME) && (
          <FormatInformation heading="Deposit fee">
            {item.deposit_return_scheme === null ? 'No deposit fee' : item.deposit_return_scheme?.toString()}
          </FormatInformation>
        )}
      </DetailsPanel>
    </>
  );
};

export default TaxRatePanel;
